module.exports = __webpack_public_path__ + "static/feature-4-18d68235968d0263b96e1d87e0b849b7.svg";